import React from 'react';

const RunbookUpdateSeveritySVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.651 4.03637L10.149 5.41152C10.1195 5.49219 10.1637 5.58107 10.2458 5.60633L11.5308 6.00172C11.607 6.02517 11.6516 6.10413 11.6322 6.18147L10.841 9.34653C10.8019 9.50259 11.0026 9.60227 11.1034 9.4769L14.5425 5.19892C14.5962 5.13214 14.5832 5.03403 14.5139 4.98363L13.2011 4.02889C13.122 3.97135 13.1182 3.85472 13.1934 3.79221L15.3017 2.04038C15.3468 2.0029 15.4096 1.99514 15.4625 2.02052L16.6094 2.57105C16.664 2.59728 16.6975 2.6538 16.6942 2.71431L16.223 11.5108C15.9928 13.3524 14.6099 17.0994 10.9397 19.1045C10.8741 19.1404 10.7938 19.0933 10.7931 19.0185L10.7479 14.3745C10.7474 14.3189 10.7923 14.2735 10.8479 14.2735H12.2241C12.3132 14.2735 12.3578 14.1658 12.2948 14.1028L9.0379 10.8459C8.9992 10.8072 8.93658 10.8068 8.89739 10.845L5.55627 14.1019C5.49203 14.1645 5.53636 14.2735 5.62607 14.2735H7.20983C7.26506 14.2735 7.30983 14.3183 7.30983 14.3735V18.9622C7.30983 19.1266 7.12357 19.2204 6.99267 19.1211C6.59282 18.8177 5.91335 18.2924 5.54543 17.9532C2.6269 15.3 2.15089 12.767 1.86282 11.2323C1.72117 10.17 1.45686 5.62333 1.32266 3.12128C1.30965 2.87864 1.47327 2.66312 1.71013 2.60884L9.50893 0.821605C9.87151 0.738514 10.1946 1.06632 10.1063 1.42766L9.78313 2.75022"
      stroke="currentcolor"
    />
  </svg>
);

export default RunbookUpdateSeveritySVG;
